import { GatsbyBrowser } from "gatsby";
import { PageViews } from "@piwikpro/react-piwik-pro";

const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({ location }) => {
  PageViews.trackPageView(location.pathname);
};

export default onRouteUpdate;
